
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { PropretyAttributes, Validation, NavigationProperty } from "../../decorators/EntityDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Visit } from "./Visit.model";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Visitor'
})
export class Visitor extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);



  @Validation({ minLength: 6, maxLength: 255, propertyType: RegexType.Email })
  pk_visitor: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  email?: string;

  @Validation({ propertyType: RegexType.NorthAmericanPhone })
  @PropretyAttributes({ attributes: [IPropretyAttribute.FilterColumn] })
  phoneNumber?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({ pattern: "^[A-ZÉÊËÈÀÂÛËÜa-zéèàêâÉÈùûëü' 0-9-]{1,255}$" })
  fullname: string = '';

  currentLanguage?: number;

  @NavigationProperty({ TargetType: Visit })
  visits?: Visit[];

  selectedPK_Visitor?: string[];

  GetType(): IEntityMetaData {
    return Visitor.getMetaData();
  }
}
